import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@fontsource-variable/inter";
// Archivo con l'asse della larghezza (62–125%): titoli al 118%, numeri grandi al 112%.
import "@fontsource-variable/archivo/wdth.css";
import "@/styles/tokens.css";
import "@/index.css";
// Dopo index.css di proposito: le durate di ida-motion/ida-motion-panel devono vincere su animate-in.
import "@/styles/motion.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
